<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-12">
          <h5>Students Reports</h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-12">
        <a-form :form="form">
        <div class="row justify-content-between align-items-center mb-2">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
            v-decorator="[
              'session_id',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please select a session!!',
                  },
                ],
                initialValue: currentSession ? currentSession.id : '',
              },
            ]"
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
              <template>
                <a-select-option
                  v-for="schoolSession in schoolSessions"
                  :value="schoolSession.id"
                  :key="schoolSession.id"
                >
                  {{ schoolSession.name }}
                  <small class="text-primary ml-2">{{
                    currentSession.id === schoolSession.id ? "Current" : ""
                  }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
              v-decorator="[
                'class_id',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select a class!!',
                    },
                  ],
                  initialValue: undefined,
                },
              ]"
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
              >
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option
                    :value="schoolClass.id"
                    :key="schoolClass.id"
                  >
                    {{ schoolClass.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              v-decorator="[
                'section_id',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select a section!!',
                    },
                  ],
                  initialValue: undefined,
                },
              ]"
              size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined"
                  >All Sections</a-select-option
                >
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                    {{ section.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Student Search -->
          <div class="col-md-4 col-12 mb-2">
            <div class="text-right">
              <a-input-search
                placeholder="Search Students.."
                size="large"
                v-model="search"
                @search="searchStudents"
                @change="searchStudents"
              />
            </div>
          </div>

          <div class="col-md-2 col-12 mb-2 text-right">
            <button
            type="button"
            class="btn btn-primary btn-with-addon"
            :loading="loading"
            @click="handleSubmit"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-upload" />
            </span>
            Export Bulk
          </button>
        </div>
        </div>
        </a-form>

        <div class="card">
          <div class="card-body">
            <students-reports :data="data" />
          </div>
        </div>
        <div class="text-right" v-if="current !== 1 && data.length < pageSize">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import StudentsReports from '@/components/student/Report/index'

import { debounce, find } from 'lodash'

export default {
  components: {
    StudentsReports,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('studentreport', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  created() {
    this.searchStudents = debounce(this.searchStudents, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
    schoolClasses: function(val) {
      if (val && val.length) {
        this.selectedClass = val[0].id
        this.getClassSections(val[0].id)
        this.getStudents()
      }
    },
  },
  data: function() {
    return {
      meta: {},
      data: [],
      current: 1,
      pageSize: 40,
      form: this.$form.createForm(this),
      loading: true,
      visible: false,
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      search: null,
      cl_id: null,
      sec_id: null,
      ses: null,
      permissionCheckSpinning: true,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getStudents: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/student', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchStudents: function(e) {
      this.search = e.target.value
      this.getStudents(true)
    },
    handleUpdateTable: function() {
      this.getStudents()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStudents()
    },
    onChange(current) {
      this.current = current
      this.getStudents()
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['section_id'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.sectionSpinning = true
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getStudents()
      } else {
        this.selectedSection = undefined
        this.getStudents()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      // this.selectedSection = undefined;
      // this.selectedClass = undefined;
      this.form.resetFields(['class_id', 'section_id'])
      this.getClasses()
      this.getStudents()
    },
    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to Export Students!`,
            onOk: () => {
              this.cl_id = this.selectedClass
              this.sec_id = this.selectedSection
              this.ses_id = this.selectedSession
              // const params = new URLSearchParams()
              // params.append("session_id", this.ses_id)
              // params.append("class_id", this.cl_id)
              // params.append("section_id", this.sec_id)
              this.$http
                .post(
                  '/api/student/export?session_id=' + this.ses_id + '&class_id=' + this.cl_id + '&section_id=' + this.sec_id,
                  {
                    headers: {
                      'content-type': 'application/json',
                      Accept: 'application/json',
                    },
                  },
                  {
                    responseType: 'arraybuffer',
                  }
                )
                .then((response) => {
                  let blob = new Blob([response.data], {
                    type: 'application/json',
                  })
                  this.loading = false
                  this.$notification['info']({
                    message: 'Student export started!',
                    description: `Student export  has started! You will be notified once it is completed!`,
                  })
                  let link = document.createElement('a')
                  link.href = window.URL.createObjectURL(blob)
                  link.download = 'Student-List.xlsx'
                  link.click()
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
          })
        }
        this.loading = false
      })
    },
  },
}
</script>
